export enum DestinationType {
    DESTINATION= 'DESTINATION',
    UNITY= 'UNITY'
}